export default "__VITE_ASSET__Cz8EZdu$__"